import { useEffect, useState } from 'react';
import { readRawCookies } from '../../utils/rawCookies';

interface CookieTrackingData {
    ireferrer: string;
    lreferrer: string;
    ilandpage: string;
    visits: string;
    ucontent: string;
    uSource: string;
    uMedium: string;
    uCampaign: string;
    marketingChannel: string;
    leadSource: string;
    IReferrer: string;
    referrer: string;
    gclid: string;
    abtastykey: string;
    swcookie: string;
    cidCookie: string;
    partnerCookieKey: string;
    date: string;
    swPageTitle: string;
}

const useCookieTracking = (): CookieTrackingData => {
    const [ireferrer, setIReferrer] = useState('');
    const [lreferrer, setLReferrer] = useState('');
    const [ilandpage, setILandPage] = useState('');
    const [visits, setVisits] = useState('');
    const [ucontent, setUContent] = useState('');
    const [uSource, setUSource] = useState('');
    const [uMedium, setUMedium] = useState('');
    const [uCampaign, setUCampaign] = useState('');
    const [marketingChannel, setMarketingChannel] = useState('');
    const [leadSource, setLeadSource] = useState('');
    const [IReferrer, setIReferrerState] = useState('');
    const [referrer, setReferrer] = useState('');
    const [gclid, setGclid] = useState('');
    const [abtastykey, setAbtastyKey] = useState('');
    const [swcookie, setSwcookie] = useState('');
    const [cidCookie, setCidCookie] = useState('');
    const [partnerCookieKey, setPartnerCookieKey] = useState('');
    const [swPageTitle, setSwPageTitle] = useState('');
    useEffect(() => {
        const cookie = readRawCookies();

        setIReferrer(cookie['_uc_referrer'] ?? '');
        setLReferrer(cookie['_uc_last_referrer'] ?? '');
        setILandPage(cookie['_uc_initial_landing_page'] ?? '');
        setVisits(cookie['_uc_visits'] ?? '');
        setUContent(cookie['_uc_utm_content'] ?? '');
        setUSource(cookie['_uc_utm_source'] ?? '');
        setUMedium(cookie['_uc_utm_medium'] ?? '');
        setUCampaign(cookie['_uc_utm_campaign'] ?? '');
        setGclid(cookie['gclid'] ?? '');
        setAbtastyKey(cookie['ABTasty']?.replace(/&/g, '$$') ?? '');
        setSwcookie(cookie['sw'] ?? '');
        setCidCookie(cookie['_ga'] ?? '');
        setPartnerCookieKey(cookie['growSumoPartnerKey'] ?? '');

        let tempMarketingChannel = '';
        let tempLeadSource = '';
        let tempIReferrer = cookie['_uc_referrer'] ?? '';
        let tempReferrer = tempIReferrer;

        if (cookie['_uc_utm_source']) {
            if (cookie['_uc_utm_medium']?.toLowerCase() === 'partner') {
                setUSource(cookie['_uc_utm_medium']);
                setUMedium(cookie['_uc_utm_source']);
            }
            tempMarketingChannel = cookie['_uc_utm_source'];
            tempLeadSource = cookie['_uc_utm_medium'];
        } else if (tempIReferrer) {
            const referrers = [
                'google',
                'facebook',
                'youtube',
                'bing',
                'yahoo',
                'duckduckgo',
            ];
            referrers.forEach((ref) => {
                if (tempIReferrer.includes(ref)) {
                    tempReferrer = ref;
                }
            });

            tempMarketingChannel = tempReferrer;
            tempLeadSource = tempIReferrer === 'direct' ? 'Direct' : 'organic';
        }

        setMarketingChannel(tempMarketingChannel.substring(0, 40));
        setIReferrer(tempIReferrer.substring(0, 255));
        setLeadSource(tempLeadSource.substring(0, 37));
        setReferrer(tempReferrer);
        setIReferrerState(tempIReferrer);
    }, []);

    const formatDate = (date: Date): string => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const getPathFromUrl = (stringUrl: string) => {
        return stringUrl.split(/[?#]/)[0];
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setSwPageTitle(getPathFromUrl(window.location.href));
        }
    }, []);

    return {
        ireferrer,
        lreferrer,
        ilandpage,
        visits,
        ucontent,
        uSource,
        uMedium,
        uCampaign,
        marketingChannel,
        leadSource,
        IReferrer,
        referrer,
        gclid,
        abtastykey,
        swcookie,
        cidCookie,
        partnerCookieKey,
        date: formatDate(new Date()),
        swPageTitle,
    };
};

export default useCookieTracking;
